<template>
  <button
    class="button is-small is-light is-success teacher-tag"
    @click="remove"
  >
    {{ getTeacherName(teacher) }}
    <span> &Cross;</span>
  </button>
</template>

<script>
export default {
  props: {
    teacher: String
  },
  methods: {
    getTeacherName(tid) {
      let output = this.$store.state.data.teachers.filter(
        teacher => teacher.id === tid
      );
      return output[0].name;
    },
    remove() {
      this.$store.dispatch("removeTeacher", this.teacher);
    }
  }
};
</script>

<style lang="scss">
.teacher-tag {
  transition: all 0.3s ease;
  margin-left: 0.5rem;
  margin-top: 0.3rem;
  position: relative;
  padding-left: 1.2rem;
  span {
    color: rgba(240, 10, 10, 0.8);
    transition: all 0.3s ease;
    position: absolute;
    left: 0.4rem;
  }
  &:hover {
    span {
      font-size: 1rem;
    }
  }
}
</style>
